<div
  *transloco="let t"
  (click)="menu.toggle($event)"
  class="flex items-center gap-2 cursor-pointer"
>
  <p-avatar [image]="user().photo" size="large" />
  <div class="hidden xl:block">
    <span class="text-[#b5b5c3] text-[13px]">{{ t('shared/hello') }} 👋</span>
    <div class="font-bold text-[14px]">{{ user().name }}</div>
  </div>
</div>
<p-menu #menu [model]="items" [popup]="true" appendTo="body" dir="rtl">
  <ng-template #item let-item>
    @if (item.route) {

    <a
      [routerLink]="item.route"
      class="p-menu-item-link flex items-center gap-2"
    >
      <span ngClass="text-sm" [class]="item.icon"></span>
      <span class="text-sm">{{ item.label }}</span>
    </a>

    } @else { @if (item.url) {
    <a [href]="item.url" class="p-menu-item-link flex items-center gap-2">
      <span ngClass="text-sm" [class]="item.icon"></span>
      <span class="text-sm">{{ item.label }}</span>
    </a>
    } @if (item.command) {
    <button
      (click)="item.command()"
      class="p-menu-item-link flex items-center gap-2"
    >
      <span ngClass="text-sm" [class]="item.icon"></span>
      <span class="text-sm">{{ item.label }}</span>
    </button>
    } }
  </ng-template>

  <p-confirmDialog [draggable]="false"></p-confirmDialog>
</p-menu>
